<template>
  <!-- 关于我们 -->
  <div class="">
    <HeaderTop />
    <MenuPage />
    <BannerDetail
      :backgroundImage="require('../assets/img/banner4.jpg')"
      :title="$t('aboutbannertitle')"
      :description="$t('aboutbannerdescription')"
    />
    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("companyprofile") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>
    <div class="companyprofile-main">
      <div class="companyprofile-box">
        <div class="companyprofile-left">
          <div class="companyprofile-left-li">
            {{ $t("companyIntroduction") }}
          </div>
          <div class="companyprofile-left-li">
            {{ $t("technologyCombination") }}
          </div>
        </div>
        <div class="companyprofile-right">
          <img src="../assets/img/about.jpg" />
        </div>
      </div>
    </div>

    <div class="serviceprovider-main-three">
      <div class="serviceprovider-main-box-three">
        <div class="serviceprovider-box">
          <NumberCounter
            :label="$t('serviceprovidertitle.label1')"
            :targetNumber="8"
            :dec="$t('serviceprovidertitle.dec1')"
          />
        </div>
        <div class="serviceprovider-box">
          <NumberCounter
            :label="$t('serviceprovidertitle.label2')"
            :targetNumber="500"
            :dec="$t('serviceprovidertitle.dec2')"
          />
        </div>
        <div class="serviceprovider-box">
          <NumberCounter
            :label="$t('serviceprovidertitle.label3')"
            :targetNumber="100"
            :dec="$t('serviceprovidertitle.dec2')"
          />
        </div>
        <div class="serviceprovider-box">
          <NumberCounter
            :label="$t('serviceprovidertitle.label4')"
            :targetNumber="30"
            :dec="$t('serviceprovidertitle.dec2')"
          />
        </div>
      </div>
    </div>

    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("smartProductionBase") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

    <div class="smartProductionBase-main">
      <div class="smartProductionBase-left"></div>
      <div class="smartProductionBase-right">
        <div>{{ $t("productionBaseDescription") }}</div>
      </div>
    </div>

    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("honors") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>
    <div class="honors-main">
      <div class="honors-box">
        <img src="../assets/img/he.jpg" />
      </div>
    </div>

    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("partners") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>
    <div class="honors-main">
      <div class="honors-box">
        <PartnerLogos />
      </div>
    </div>

    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("contactUs") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>
    <div class="contactUs-main">
      <div class="contactUs-box">
        <div class="left-one">
          <div class="right">
            <img   :src=" $t('image6') " /><br />
            <p>{{ $t("codedec") }}</p>
          </div>
          <div class="left-two">
            <div class="left-title">
              {{ $t("WhatsApp") }}: {{ $t("WhatsAppvalue") }}
            </div>
            <div class="left-title">
              {{ $t("WhatsApp2") }}:{{ $t("WhatsApp2value") }}
            </div>
            <div class="left-title">
              {{ $t("email") }}
            </div>
            <div class="left-title">
              {{ $t("address") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-main">
      {{ $t("footertitile") }}
    </div>
  </div>
</template>

<script>
import MenuPage from "../components/MenuPage.vue";
import HeaderTop from "../components/HeaderTop.vue";
import BannerDetail from "@/components/BannerDetail.vue";
import PartnerLogos from "@/components/PartnerLogos2.vue";
import NumberCounter from "../components/NumberCounter.vue";
export default {
  components: {
    HeaderTop,
    MenuPage,
    BannerDetail,
    PartnerLogos,
    NumberCounter,
  },
  name: "NewsPage",
};
</script>
<style scoped>
.contactUs-main {
  float: left;
  width: 100%;
  background: #f6f6f6;
}
.contactUs-box {
  width: 1200px;
  margin: 0 auto;
}
.honors-main {
  float: left;
  width: 100%;
  background: #f6f6f6;
}

.honors-box {
  width: 1200px;
  margin: 0 auto;
}

.honors-box img {
  float: left;
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid #eee;
}

.left {
  width: 30%;
}
.left-one {
  float: left;
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid #eee;
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
}
.left-two {
  padding: 20px 0 10px 0;
  box-sizing: border-box;
}
.left-title {
  width: 100%;
  margin-bottom: 30px;
}
.right {
  text-align: center;
  margin-right: 20px;
  margin-top: 20px;
}
.right img {
  width: 200px;
  height: 200px;
}
.smartProductionBase-main {
  float: left;
  width: 100%;
}

.smartProductionBase-left {
  float: left;
  width: 50%;
  background: url("../assets/img/vidio1.gif") center center;
  background-size: cover;
  height: 700px;
}

.smartProductionBase-right {
  float: right;
  width: 50%;
  background: #d1261e;
  padding: 0 50px;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  height: 700px;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  text-indent: 2em;
  font-size: 18px;
}
.companyprofile-main {
  float: left;
  width: 100%;
  background: #f6f6f6;
}
.companyprofile-box {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.companyprofile-left {
  width: 50%;
  padding-right: 20px;
  box-sizing: border-box;
}
.companyprofile-left-li {
  text-indent: 2em;
  line-height: 30px;
  font-size: 18px;
}

.companyprofile-right {
  width: 50%;
}
.companyprofile-right img {
  width: 100%;
}

@media (max-width: 1200px) {
  .contactUs-box {
    float: left;
    width: 100%;
  }
  .honors-box {
    float: left;
    width: 100%;
  }
  .left-one {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .companyprofile-box {
    float: left;
    width: 100%;
    justify-content: space-between;
    flex-direction: column;
  }
  .companyprofile-left {
    font-size: 14px;
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
  }
  .companyprofile-right {
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
  }

  .smartProductionBase-left {
    float: left;
    width: 100%;
    height: 300px;
  }

  .smartProductionBase-right {
    float: left;
    width: 100%;
    height: 600px;
  }
}
</style>
